import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'unco-metrica',
  templateUrl: './metrica.html',
  styleUrls: ['./metrica.scss']
})
export class Metrica {

  @Input() title: string = '';
  color: string = '';
  _width: number = 0;
  _value: number = 0;
  @Input() set data(data: number[]) {
    // index 0 el valor, index 1 el total
    const percentage = ((data[0] || 0) / (data[1] || 1)) * 100;
    this._width = Math.min(percentage, 100);
    this._value = data[0];
    this.color = this._width <= 30 ? 'red' : (this._width <= 60 ? 'orange' : 'green');
  }

  constructor() {
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/metrica/metrica.ts